import { View, Table as ZincUiTable } from '@zinc/ui';
import { Col } from 'bz-core-controls';
import Field from 'bz-core-controls/controls/form/field/field';
import FieldInteger from 'bz-core-controls/controls/form/field/field-integer';
import FieldSelect from 'bz-core-controls/controls/form/field/field-select';
import Button from 'bz-core-controls/controls/general/button';
import OutlineButton from 'bz-core-controls/controls/general/outline-button';
import _ from 'lodash';
import React, { Component } from 'react';
import { DataSourceMenu, DataSourceMenuItem } from '../../../../../controls/data-source';

class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeColumn: {},
      dialogOpen: false
    };
  }

  onAdd() {
    let { columns } = this.props;
    this.setState({
      dialogOpen: true,
      columns: columns,
      activeColumn: {},
      activeIndex: -1
    });
  }

  onEdit(column) {
    let { columns } = this.props;
    this.setState({
      dialogOpen: true,
      activeColumn: column,
      activeIndex: columns.indexOf(column)
    });
  }

  onApply() {
    let { columns, title } = this.props;
    let { activeColumn, activeIndex } = this.state;
    if (!activeColumn.field) activeColumn.field = _.uniqueId(activeColumn.type + '_');

    if (activeIndex == -1) columns.push(activeColumn);
    else columns[activeIndex] = activeColumn;

    this.setState({
      dialogOpen: false
    });

    this.props.onChange({ title: title, columns });
  }

  onCancel() {
    this.setState({
      dialogOpen: false,
      activeColumn: {}
    });
  }

  onColumnChange(key, value) {
    let { activeColumn } = this.state;
    activeColumn[key] = value;
    this.setState({ activeColumn });
  }

  render() {
    let { title, columns } = this.props;
    let { adding, dialogOpen, activeColumn, activeIndex } = this.state;

    const columnView = (columns || []).map((x, i) => (
      <ZincUiTable.Row key={i}>
        <ZincUiTable.Cell>{x.label}</ZincUiTable.Cell>
        <ZincUiTable.Cell>{x.type}</ZincUiTable.Cell>
        <ZincUiTable.Cell>
          <OutlineButton label="Edit" onClick={this.onEdit.bind(this, x)} />
        </ZincUiTable.Cell>
      </ZincUiTable.Row>
    ));
    let dialog = null;
    if (dialogOpen)
      dialog = (
        <TableDialog
          {...activeColumn}
          store={this.props.store}
          onChange={this.onColumnChange.bind(this)}
          onApply={this.onApply.bind(this)}
          onCancel={this.onCancel.bind(this)}
          editing={activeIndex != -1}
        />
      );
    return (
      <View padding={2} gap={2}>
        <ZincUiTable border={true}>
          <ZincUiTable.Head>
            <ZincUiTable.Row>
              <ZincUiTable.Heading>Name</ZincUiTable.Heading>
              <ZincUiTable.Heading>Type</ZincUiTable.Heading>
              <ZincUiTable.Heading />
            </ZincUiTable.Row>
          </ZincUiTable.Head>
          <ZincUiTable.Body>{columnView}</ZincUiTable.Body>
        </ZincUiTable>

        {!dialogOpen && (
          <Button variant="outline" onClick={this.onAdd.bind(this)} label="Add Column" />
        )}
        <View>{dialog}</View>
      </View>
    );
  }
}

class TableDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentField: '',
      menu: 'datasource',
      transition: ''
    };
  }

  set(key, value) {
    this.props.onChange(key, value);
  }

  onNavigate(key, dir) {
    this.setState({
      menu: key,
      transition: `slide-${dir}`
    });
  }

  onClick(value) {
    this.setState({
      menu: 'datasource',
      transition: 'slide-left'
    });
    this.props.onChange('src', value);
  }

  render() {
    let { onChange, onCancel, onApply, type, label, src, mode, unit, min, max, editing } =
      this.props;
    let { lookups } = this.props.store;
    let { currentField } = this.state;

    let extra = null;
    const content = {
      datasource: () => {
        let label = 'Select a lookup:';
        let name = lookups[src] ? lookups[src].niceName || lookups[src].name || src : src;
        if (src && src.length > 0) label = 'Selected Lookup: ' + name;
        return (
          <div>
            <DataSourceMenu label={label}>
              <DataSourceMenuItem
                label="Custom"
                next={true}
                icon="fa-puzzle-piece"
                onClick={this.onNavigate.bind(this, 'custom', 'left')}
              />
              <DataSourceMenuItem
                label="Lookup"
                next={true}
                icon="fa-info-circle"
                onClick={this.onNavigate.bind(this, 'lookup', 'left')}
              />
              <DataSourceMenuItem
                label="Search"
                next={true}
                icon="fa-search"
                onClick={this.onNavigate.bind(this, 'search', 'left')}
              />
            </DataSourceMenu>
          </div>
        );
      },
      custom: () => {
        let { lists } = this.props.store;

        let items = Object.keys(lists).map((x, i) => {
          return <DataSourceMenuItem key={i} label={x} onClick={this.onClick.bind(this, x)} />;
        });

        return (
          <DataSourceMenu
            label="Custom"
            onNavigate={this.onNavigate.bind(this, 'datasource', 'right')}
          >
            {items}
          </DataSourceMenu>
        );
      },
      lookup: () => {
        let items = Object.keys(lookups).map((x, i) => {
          let name = lookups[x].niceName || lookups[x].name || x;
          return <DataSourceMenuItem key={i} label={name} onClick={this.onClick.bind(this, x)} />;
        });

        return (
          <DataSourceMenu
            label="Lookup"
            onNavigate={this.onNavigate.bind(this, 'datasource', 'right')}
          >
            {items}
          </DataSourceMenu>
        );
      },
      search: () => {
        let { searches } = this.props.store;
        let items = Object.keys(searches).map((x, i) => {
          return <DataSourceMenuItem key={i} label={x} onClick={this.onClick.bind(this, x)} />;
        });

        return (
          <DataSourceMenu
            label="Search"
            onNavigate={this.onNavigate.bind(this, 'datasource', 'right')}
          >
            {items}
          </DataSourceMenu>
        );
      }
    };

    switch (type) {
      case 'numeric':
        extra = (
          <div>
            <Col xs={4}>
              <Field label="Unit" value={unit} onChange={(e) => this.set('unit', e.target.value)} />
            </Col>
            <Col xs={4}>
              <FieldInteger label="Min" value={min} onChange={(v) => this.set('min', v)} />
            </Col>
            <Col xs={4}>
              <FieldInteger label="Max" value={max} onChange={(v) => this.set('max', v)} />
            </Col>
          </div>
        );
        break;
      case 'lookup':
        extra = <div>{content[this.state.menu]()}</div>;
        break;
      case 'textlookup':
        extra = <div>{content[this.state.menu]()}</div>;
        break;
    }
    return (
      <View>
        <View>
          <Field
            liveOnChange={true}
            label="Name"
            value={label}
            onChange={(e) => this.set('label', e.target.value)}
          />
          <FieldSelect
            label="Type"
            displayMember="name"
            valueMember="type"
            value={type}
            onChange={(e) => this.set('type', e.target.value)}
            items={[
              { type: 'date', name: 'Date' },
              { type: 'datetime', name: 'Date & Time' },
              { type: 'lookup', name: 'Lookup' },
              { type: 'text', name: 'Text' },
              { type: 'textlookup', name: 'Text with Lookup' },
              { type: 'numeric', name: 'Number' }
            ]}
          />
          {extra}
        </View>
        <View direction="row" gap={2} align="end" padding={2}>
          <Button label="Cancel" variant="outline" color="secondary" onClick={onCancel} />
          {!editing ? (
            <Button disabled={!(!!label && !!type)} label="Apply" onClick={onApply} />
          ) : null}
        </View>
      </View>
    );
  }
}

export default Table;
